module.exports = __webpack_public_path__ + "img/the_2021_dust_2_collection.9ccc4d5f.png";